<template>
  <v-col cols="12">
    <v-row>
      <template v-for="(user, indexUser) in users">
        <v-col cols="12" :key="user.passenger_id">
          <fieldset class="custom-fieldset">
            <legend>
              {{ $t("travelService.chooseOfferForm.passenger") }}
              {{ indexUser + 1 }}
              <template v-if="!readonly">
                <v-tooltip bottom v-if="user.company_user_id && $store.getters.hasPermission('saveUserDataFromTravelService')">
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" @click="saveInUserProfile(user)" class="my-0 py-0" :disabled="!isUserDataDifferentFromUserProfile(user)">
                      <v-icon>fa-cloud-upload-alt</v-icon>
                    </v-btn>
                  </template>
                  {{ $t("global.saveInUserProfile") }}
                </v-tooltip>
                <v-tooltip bottom v-if="user.company_user_id">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      v-on="on"
                      @click="changedPassengerId(user, user.company_user_id)"
                      class="my-0 py-0"
                      :disabled="!isUserDataDifferentFromUserProfile(user)"
                    >
                      <v-icon>fa-cloud-download-alt</v-icon>
                    </v-btn>
                  </template>
                  {{ $t("components.travelUserInlineForm.loadFromUserProfile") }}
                </v-tooltip>
              </template>
            </legend>
            <v-row>
              <v-col class="pa-1" cols="3">
                <v-autocomplete
                  :clearable="!readonly"
                  :items="userList"
                  :label="$t('travelService.chooseOfferForm.delegationSystemUser')"
                  :readonly="readonly"
                  @change="value => changedPassengerId(user, value)"
                  v-model="user.company_user_id"
                />
              </v-col>
              <v-col class="pa-1" v-if="user.company_user_id == null" cols="3">
                <v-text-field :label="$t('user.name') + '*'" :readonly="readonly" :rules="[isRequired]" v-model="user.name" />
              </v-col>
              <v-col class="pa-1" v-if="user.company_user_id == null" cols="3">
                <v-text-field :label="$t('user.surname') + '*'" :readonly="readonly" :rules="[isRequired]" v-model="user.surname" />
              </v-col>
              <v-col class="pa-1" v-if="requiredProps.is_middle_name_required" cols="3">
                <v-text-field
                  :label="$t('settings.users.basicData.fields.middleName.name') + '*'"
                  :readonly="readonly"
                  :rules="[isRequired]"
                  v-model="user.middle_name"
                />
              </v-col>
              <v-col class="pa-1" v-if="requiredProps.is_document_number_required" cols="3">
                <v-text-field :label="$t('user.documentNumber') + '*'" :readonly="readonly" :rules="[isRequired]" v-model="user.document_number" />
              </v-col>
              <v-col class="pa-1" v-if="requiredProps.is_document_expire_required" cols="3">
                <date-picker :label="$t('user.documentExpire') + '*'" :model.sync="user.document_expire" :rules="[isRequired]" v-if="!readonly" />
                <v-text-field :label="$t('user.documentExpire') + '*'" :readonly="readonly" v-if="readonly" v-model="user.document_expire" />
              </v-col>
              <v-col class="pa-1" v-if="requiredProps.is_document_issue_place_required" cols="3">
                <v-text-field :label="$t('global.documentIssuePlace') + '*'" :readonly="readonly" :rules="[isRequired]" v-model="user.document_issue_place" />
              </v-col>
              <v-col class="pa-1" v-if="requiredProps.is_phone_required" cols="3">
                <v-text-field :label="$t('user.phone') + '*'" :readonly="readonly" :rules="[isRequired]" v-model="user.phone" />
              </v-col>
              <v-col class="pa-1" v-if="requiredProps.is_birth_date_required" cols="3">
                <date-picker :label="$t('user.birthDate') + '*'" :model.sync="user.birth_date" :rules="[isRequired]" v-if="!readonly" />
                <v-text-field :label="$t('user.birthDate') + '*'" :readonly="readonly" v-if="readonly" v-model="user.birth_date" />
              </v-col>
              <v-col class="pa-1" v-if="requiredProps.is_email_required" cols="3">
                <v-text-field :label="$t('user.email') + '*'" :readonly="readonly" :rules="[isRequired, emailValidation]" v-model="user.email" />
              </v-col>
              <v-col class="pa-1" v-if="requiredProps.is_nationality_required" cols="3">
                <v-text-field
                  :label="$t('settings.users.basicData.fields.nationality.name') + '*'"
                  :readonly="readonly"
                  :rules="[isRequired]"
                  v-model="user.nationality"
                />
              </v-col>
              <v-col class="pa-1" v-if="requiredProps.is_residence_address_required" cols="3">
                <v-text-field :label="$t('global.residenceAddress') + '*'" :readonly="readonly" :rules="[isRequired]" v-model="user.residence_address" />
              </v-col>
            </v-row>
          </fieldset>
        </v-col>
      </template>
    </v-row>
  </v-col>
</template>

<script>
import DatePicker from "../CustomInputComponents/DatePicker";
import isEmail from "validator/lib/isEmail";

export default {
  name: "TravelUsersInlineForm",
  components: { DatePicker },
  data: () => ({
    copyPropertyList: [
      "birth_date",
      "document_expire",
      "document_issue_place",
      "document_number",
      "email",
      "middle_name",
      "name",
      "nationality",
      "phone",
      "residence_address",
      "surname"
    ]
  }),
  props: {
    availableUsers: {
      required: true
    },
    requiredProps: {
      required: true
    },
    users: {
      required: true
    },
    readonly: {
      required: false,
      default: false
    }
  },
  computed: {
    userList() {
      let result = [];
      for (let user of this.availableUsers) {
        result.push({ text: user.name + " " + user.surname, value: user.id });
      }
      return result;
    },
    contextUsers: {
      get() {
        return this.users;
      },
      set(value) {
        this.$emit("update:users", value);
      }
    }
  },
  methods: {
    isUserDataDifferentFromUserProfile(user) {
      let selectedUser = this.availableUsers.find(v => v.id === user.company_user_id);
      if (typeof selectedUser !== "undefined") {
        for (let propertyName of this.copyPropertyList) {
          if (user[propertyName] !== selectedUser[propertyName]) {
            return true;
          }
        }
      }
      return false;
    },
    saveInUserProfile(user) {
      this.$store
        .dispatch("confirmDialog", {
          content: this.$t("components.travelUserInlineForm.saveDialog.content"),
          title: this.$t("components.travelUserInlineForm.saveDialog.title")
        })
        .then(() => {
          this.axios.post("travel-service/save-user-data-in-user-profile", user).then(() => {
            this.$store.dispatch("snackbarPush", {
              text: this.$t("global.saved"),
              position: "down"
            });
            this.$emit("saved");
          });
        })
        .catch();
    },
    changedPassengerId(item, val) {
      let selectedUser = this.availableUsers.find(v => v.id === val);
      if (typeof selectedUser === "undefined") {
        for (let propertyName of this.copyPropertyList) {
          item[propertyName] = null;
        }
      } else {
        for (let propertyName of this.copyPropertyList) {
          item[propertyName] = selectedUser[propertyName];
        }
      }
    },
    isRequired(v) {
      return (v != null && v.length > 0) || this.$t("global.error.required");
    },
    emailValidation(v) {
      return v === null || isEmail(v) || this.$t("user.validation.emailMustBeValid");
    }
  }
};
</script>

<style scoped></style>
